import { render } from "./CourseDetailModal.vue?vue&type=template&id=3ccc2558&scoped=true"
import script from "./CourseDetailModal.vue?vue&type=script&lang=js"
export * from "./CourseDetailModal.vue?vue&type=script&lang=js"

import "./CourseDetailModal.vue?vue&type=style&index=0&id=3ccc2558&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ccc2558"]])

export default __exports__